import React from 'react'
import { FormikProps } from 'formik'
import { UserFormValues, useSubperson } from '@modmd/data'
import { Dropdown } from 'components/AutoCompleteDropdown'

export interface Props {
  userForm?: FormikProps<UserFormValues>
  userData?: UserFormValues
}

const AddSubperson: React.VFC<Props> = ({ userData, userForm }) => {
  const { data: subperson, loading: isSubpersonLoading } = useSubperson({
    userId: userData?.id ?? '',
  })
  const [selectedValue, setSelectedValue] = React.useState<number>()

  return (
    <Dropdown
      disabled={subperson?.subperson ? !subperson.subperson.length : true}
      label="Subperson"
      name="user"
      value={selectedValue}
      isLoading={isSubpersonLoading}
      options={subperson?.subperson?.map((e, index) => ({
        value: index,
        text: e?.firstName,
      }))}
      isWithOptionsFilter={false}
      selectOnNavigation={false}
      onSelectChange={(_: React.SyntheticEvent<HTMLElement>, data: { value: number }) => {
        try {
          setSelectedValue(data.value)
          userForm?.setValues({
            id: subperson?.subperson![data.value]?.id,
            firstName: subperson?.subperson![data.value]?.firstName,
            lastName: subperson?.subperson![data.value]?.lastName,
            birthDate: subperson?.subperson![data.value]?.birthDate,
            ethnicity: subperson?.subperson![data.value]?.ethnicity,
            race: subperson?.subperson![data.value]?.race,
            gender: subperson?.subperson![data.value]?.gender,
            parentId: subperson?.subperson![data.value]?.id,
            email: userData?.email,
            Address: subperson?.subperson![data.value]?.Address,
          } as UserFormValues)
        } catch (e) {
          //
        }
      }}
    />
  )
}

export { AddSubperson }
